export const Workflow = () => {
  return (
    <div>
      <section>
        {/* Design & Verification workflow */}
        <div className="bg-white">
          <div className="max-w-screen-2xl mx-auto">
            <div className=" w-full p-7 py-12 lg:py-24 flex flex-col-reverse lg:flex-row gap-8 sm:gap-16 lg:gap-32">
              <div className="basis-1/2  self-center">
                <img
                  src="/images/VLSI/design & verification_workflow.svg"
                  className="w-96 md:w-2/3 lg:w-fit mx-auto"
                />
              </div>
              <div className="basis-1/2 flex flex-col gap-3 sm:gap-6 lg:gap-12">
                <div className="text-3xl sm:text-4xl lg:text-6xl font-extrabold">
                Rigorous Design and Verification
                </div>
                <div className="text-xl sm:text-2xl lg:text-3xl text-zinc-600">
                Pushing the boundaries of innovation in semiconductor design and validation.
                </div>
                <ul className=" list-disc list-outside text-xl sm:text-2xl lg:text-3xl font-semibold flex flex-col gap-2 sm:gap-4 lg:gap-8 text-zinc-600 px-4 sm:px-6">
                  <li>Enhanced Performance Acceleration</li>
                  <li>Tailored Customization Solutions</li>
                  <li>Streamlined Data Control Efficiency</li>
                  <li>Synergistic Collaborative Excellence</li>
                  <li>Design Optimization for Peak Efficiency</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Design & Verification workflow ENDS */}

        {/* Physical Design workflow */}
        <div className="bg-[#F7F9FF]">
          <div className="max-w-screen-2xl mx-auto">
            <div className=" w-full p-7 py-12 lg:py-24 flex flex-col-reverse lg:flex-row-reverse gap-8 sm:gap-16 lg:gap-32">
              <div className="basis-1/2  self-center">
                <img
                  src="/images/VLSI/physical design_workflow.svg"
                  className="w-96 md:w-2/3 lg:w-fit mx-auto"
                />
              </div>
              <div className="basis-1/2 flex flex-col gap-3 sm:gap-6 lg:gap-12">
                <div className="text-3xl sm:text-4xl lg:text-6xl font-extrabold">
                High-Precision Physical Design
                </div>
                <div className="text-xl sm:text-2xl lg:text-3xl text-zinc-600">
                Crafting precise, performance-optimized physical layouts
                </div>
                <ul className=" list-disc list-outside text-xl sm:text-2xl lg:text-3xl font-semibold flex flex-col gap-2 sm:gap-4 lg:gap-8 text-zinc-600 px-4 sm:px-6">
                  <li>Technology Node Assessment and Library Evaluation</li>
                  <li>High-Efficiency Synthesis Strategies</li>
                  <li>Strategic DFT Insertion and Optimization</li>
                  <li>Rigorous Formal Verification Methods</li>
                  <li>Optimized Placement and Routing</li>
                  <li>Comprehensive Physical Verification Protocols</li>
                  <li>Precision Timing Closure Practices</li>
                  <li>Thorough Power and IR Analysis</li>
                  <li>Post-Silicon Metal-Only ECO Management</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Physical Design workflow ENDS */}

        {/*Firmware workflow */}
        <div className="bg-white">
          <div className="max-w-screen-2xl mx-auto">
            <div className=" w-full p-7 py-12 lg:py-24 flex flex-col-reverse lg:flex-row gap-8 sm:gap-16 lg:gap-32">
              <div className="basis-1/2  self-center">
                <img
                  src="/images/VLSI/embedded and firmware_workflow.svg"
                  className="w-96 md:w-2/3 lg:w-fit mx-auto"
                />
              </div>
              <div className="basis-1/2 flex flex-col gap-3 sm:gap-6 lg:gap-12">
                <div className="text-3xl sm:text-4xl lg:text-6xl font-extrabold">
                Advanced Firmware Solutions
                </div>
                <div className="text-xl sm:text-2xl lg:text-3xl text-zinc-600">
                Elevating firmware solutions to meet the demands of the future
                </div>
                <ul className=" list-disc list-outside text-xl sm:text-2xl lg:text-3xl font-semibold flex flex-col gap-2 sm:gap-4 lg:gap-8 text-zinc-600 px-4 sm:px-6">
                  <li>Innovative Embedded Application Development</li>
                  <li>Advanced Transaction-Level Modeling (TLM) Expertise</li>
                  <li>Efficient RTL Software Simulation</li>
                  <li>Robust Testing and Automation Solutions</li>
                  <li>Mastery in Testing Frameworks</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* firmware workflow ENDS */}

        {/*IC Packaging workflow */}
        <div className="bg-[#F7F9FF]">
          <div className="max-w-screen-2xl mx-auto">
            <div className=" w-full p-7 py-12 lg:py-24 flex flex-col-reverse lg:flex-row-reverse gap-8 sm:gap-16 lg:gap-32">
              <div className="basis-1/2  self-center">
                <img
                  src="/images/VLSI/ic packaging_workflow.svg"
                  className="w-96 md:w-2/3 lg:w-fit mx-auto"
                />
              </div>
              <div className="basis-1/2 flex flex-col gap-3 sm:gap-6 lg:gap-12">
                <div className="text-3xl sm:text-4xl lg:text-6xl font-extrabold">
                Next-Gen IC Package Design
                </div>
                <div className="text-xl sm:text-2xl lg:text-3xl text-zinc-600">
                Shaping the future of IC packaging with innovation and precision
                </div>
                <ul className=" list-disc list-outside text-xl sm:text-2xl lg:text-3xl font-semibold flex flex-col gap-2 sm:gap-4 lg:gap-8 text-zinc-600 px-4 sm:px-6">
                  <li>Silicon Initiation Assistance for expert guidance and support.</li>
                  <li>Package Feasibility in assessing size, cost, and materials.</li>
                  <li>Package Design with tailored solutions.</li>
                  <li>Package Release to ensure a seamless transition.</li>
                  <li>Engineering Build for meticulous construction.</li>
                  <li>Verification through rigorous testing and analysis.</li>
                  <li>Production of excellence from prototype to mass production.</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* IC Packaging workflow ENDS */}

        {/*Infrastructure workflow */}
        <div className="bg-white">
          <div className="max-w-screen-2xl mx-auto">
            <div className=" w-full p-7 py-12 lg:py-24 flex flex-col-reverse lg:flex-row gap-8 sm:gap-16 lg:gap-32">
              <div className="basis-1/2  self-center">
                <img
                  src="/images/VLSI/infrastructure_workflow.svg"
                  className="w-96 md:w-2/3 lg:w-fit mx-auto"
                />
              </div>
              <div className="basis-1/2 flex flex-col gap-3 sm:gap-6 lg:gap-12">
                <div className="text-3xl sm:text-4xl lg:text-6xl font-extrabold">
                Infrastructure
                </div>
                <div className="text-xl sm:text-2xl lg:text-3xl text-zinc-600">
                  In-house expertise for setup and maintenance of secured Amazon
                  AWS infrastructure to serve clients
                </div>
                <ul className=" list-disc list-outside text-xl sm:text-2xl lg:text-3xl font-semibold flex flex-col gap-2 sm:gap-4 lg:gap-8 text-zinc-600 px-4 sm:px-6">
                  <li>State-of-the-art cloud security</li>
                  <li>Highly scalable</li>
                  <li>Cost effective</li>
                  <li>Cross platform syncing</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        {/* Infrastructure workflow ENDS */}
      </section>
    </div>
  );
};
